import { PromoPaginationParams } from '../models';

export const FOREMAN_PROMOCODES_PAGE_SIZE = 10;

export const DEFAULT_PROMO_PAGINATION_PARAMS: PromoPaginationParams = {
  startIndex: 0,
  pageSize: FOREMAN_PROMOCODES_PAGE_SIZE,
};
